<lx-loading-spinner i18n-message message="Loading School Info..." [loading]="loading" shadingColor="rgba(0,0,0,0.5)"></lx-loading-spinner>

<lx-section-template [sectionIndex]="sectionIndex" i18n-sectionTitle sectionTitle="Select course">
  <ng-container *ngFor="let course of sectionModel.courses; let courseIndex = index; let isLast = last">
    <lx-course-type-selector
      *ngIf="courseTypeSelectorEnabled"
      label="Course Type"
      i18n-label
      class="qt-form-section__start-new-line form-field__validated-selector-padding"
      [disabled]="!productSchool"
      [codes]="availableCourseTypes"
      [buttonView]="false"
      [value]="course.courseType?.code"
      [required]="courseIndex === 0"
      [ageGroup]="ageGroup"
      [iconValidation]="true"
      (itemChange)="courseTypeChanged(courseIndex, $event)"
      [attr.data-qa]="'qt-course-type-selector-' + courseIndex"
    ></lx-course-type-selector>

    <lx-level-selector
      class="form-field__validated-selector-padding"
      [value]="course.level?.code"
      [disabled]="!productSchool || (courseTypeSelectorEnabled && !course.courseType)"
      [schoolCode]="schoolCodeForLevels"
      [codes]="courseOptions[courseIndex]?.availableLevels"
      [required]="courseIndex === 0"
      [ngClass]="{ 'qt-form-section__start-new-line': !courseTypeSelectorEnabled }"
      (itemChange)="levelChange(courseIndex, $event)"
      [attr.data-qa]="'qt-language-level-selector-' + courseIndex"
    ></lx-level-selector>

    <lx-form-field-selector
      label="Course"
      class="form-field__validated-selector-padding"
      i18n-label
      *ngIf="courseSelectorEnabled"
      [disabled]="!course.level || (courseTypeSelectorEnabled && !course.courseType) || !productSchool"
      [value]="courseOptionExist(courseIndex, course.relatedCourseCode) ? course.relatedCourseCode : course.code"
      valueExpr="code"
      [itemList]="courseOptions[courseIndex]?.courses"
      [autofill]="true"
      [required]="courseIndex === 0"
      [iconValidation]="true"
      (valueChange)="courseChanged(courseIndex, $event)"
      [attr.data-qa]="'qt-course-selector-' + courseIndex"
    ></lx-form-field-selector>

    <div>
      <!-- Show Date List Selector when dateListEnabled is true -->
      <lx-date-list-selector
        *ngIf="courseOptions[courseIndex]?.dateListEnabled"
        i18n-label
        label="Start Date"
        i18n-placeholder
        placeholder="— Please select  —"
        class="form-field__validated-selector-padding"
        [disabled]="courseSelectorEnabled ? !course.code : !course.level"
        [value]="course.startDate"
        [dates]="courseOptions[courseIndex]?.availableStartDates"
        [required]="courseIndex === 0"
        [iconValidation]="true"
        [ngClass]="{ 'qt-form-section__start-new-line': !courseTypeSelectorEnabled && !courseSelectorEnabled }"
        (valueChange)="startDateChangeFromSelector(courseIndex, $event)"
        [attr.data-qa]="'qt-start-date-selector-' + courseIndex"
      ></lx-date-list-selector>

      <!-- Show Date Picker when dateListEnabled is false (default) -->
      <lx-date-picker-field
        *ngIf="!courseOptions[courseIndex]?.dateListEnabled"
        i18n-label
        label="Start Date"
        i18n-placeholder
        placeholder="— Please select  —"
        class="form-field__validated-selector-padding"
        [disabled]="courseSelectorEnabled ? !course.code : !course.level"
        [dateValue]="course.startDate"
        [minDate]="courseOptions[courseIndex]?.minDate"
        [defaultDate]="courseOptions[courseIndex]?.minDate"
        [disabledDates]="courseOptions[courseIndex]?.disabledDates"
        [showCalendarIcon]="true"
        [required]="courseIndex === 0"
        [iconValidation]="true"
        [ngClass]="{ 'qt-form-section__start-new-line': !courseTypeSelectorEnabled && !courseSelectorEnabled }"
        (dateChanged)="startDateChange(courseIndex, $event)"
        (calendarShown)="prepareCalendar(courseIndex, $event)"
        (monthChanged)="monthChanged(courseIndex, $event)"
        [attr.data-qa]="'qt-start-date-field-' + courseIndex"
      ></lx-date-picker-field>
      <div class="form-field-sections__disclaimer" i18n *ngIf="showDisclaimerDatesToBeConfirmed">Dates to be confirmed</div>
    </div>

    <lx-weeks-selector
      label="Duration"
      i18n-label
      class="form-field__validated-selector-padding"
      [disabled]="!course.startDate"
      [value]="course.weeks"
      [availableWeeksValues]="courseOptions[courseIndex]?.availableWeeksValues"
      [required]="courseIndex === 0"
      [iconValidation]="true"
      (valueChange)="durationChange(courseIndex, $event)"
      [attr.data-qa]="'qt-duration-field-' + courseIndex"
    ></lx-weeks-selector>
    <div *ngIf="courseSelectorEnabled">
      <lx-button
        i18n-text
        text="Delete the course above"
        [icon]="'pi pi-times'"
        [iconPos]="'before'"
        [iconFill]="true"
        [disabled]="!productSchool || sectionModel.courses.length < 2"
        [iconRounded]="true"
        [buttonStyle]="'plain-text'"
        [attr.data-qa]="'qt-remove-course-' + courseIndex"
        (buttonClick)="removeCourse(courseIndex)"
      >
      </lx-button>
    </div>
    <div *ngIf="isLast && courseSelectorEnabled && hasAvailableCourseOptions()">
      <lx-button
        i18n-text
        text="Add a course"
        [icon]="'pi pi-plus'"
        [iconPos]="'before'"
        [iconFill]="true"
        [disabled]="!course.weeks"
        [iconRounded]="true"
        [buttonStyle]="'plain-text'"
        [attr.data-qa]="'qt-add-course-' + courseIndex"
        (buttonClick)="addCourse()"
      >
      </lx-button>
    </div>
  </ng-container>

  <lx-form-field-selector
    *ngIf="accommodationTypeSelectorEnabled"
    class="form-field__validated-selector-padding"
    label="Accommodation Type"
    i18n-label
    [disabled]="!sectionModel.courses[0].weeks"
    valueExpr="code"
    [itemList]="accommodationTypes"
    [required]="true"
    [iconValidation]="true"
    (itemChange)="accommodationTypeChanged($event)"
    data-qa="pr-accommodation-type-field"
  ></lx-form-field-selector>

  <lx-form-field
    label="Please tell us more about your project"
    i18n-label
    *ngIf="specialRequestsFieldEnabled"
    class="qt-form-section__double-column-span form-field__no-validation"
    [disabled]="!sectionModel.courses[0].weeks"
    [required]="false"
    [small]="true"
    [isValid]="true"
    [iconValidation]="true"
    data-qa="pr-customer-project-field"
  >
    <textarea
      placeholder="Leave your message here"
      class="qt-form-section__textarea"
      i18n-placeholder
      (ngModelChange)="specialRequestsChanged($event)"
      [(ngModel)]="specialRequests"
      [autoResize]="false"
      pInputTextarea
    ></textarea>
  </lx-form-field>
</lx-section-template>
